









import Vue from 'vue'
import {Component, Prop, Watch} from "vue-property-decorator";

@Component
export default class Types extends Vue{
  @Prop(String) readonly defaultType!: string;

  type = this.defaultType;

  selectType(type: string){
    if (type !== '-' && type !== '+'){
      throw new Error('type is unknow');
    }
    this.type = type;
  }
  @Watch('type')
  onTypeChanged(newValue: string){
    this.$emit('update:defaultType', newValue)
  }
}
